module.exports = __webpack_public_path__ + "img/283.3a1d3f21.png";